<template>
  <v-row dense>
    <v-col cols="12" md="4">
      <v-text-field
        :value="value.region"
        @input="emit('region', $event)"
        label="Región"
        outlined dense
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="4">
      <ValidationProvider name="Ciudad" rules="required" v-slot="{ errors }">
        <v-text-field
          :value="value.city"
          @input="emit('city', $event)"
          label="Ciudad"
          outlined dense
          :error-messages="errors"
          :disabled="readonly"
          :hint="readonly ? 'Sincronizado con Relbase' : ''"
          :persistent-hint="readonly"
        ></v-text-field>
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="4">
      <ValidationProvider name="Comuna" rules="required" v-slot="{ errors }">
        <v-text-field
          :value="value.comune"
          @input="emit('comune', $event)"
          label="Comuna"
          outlined dense
          :error-messages="errors"
          :disabled="readonly"
          :hint="readonly ? 'Sincronizado con Relbase' : ''"
          :persistent-hint="readonly"
        ></v-text-field>
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="6">
      <ValidationProvider name="Calle" rules="required" v-slot="{ errors }">
        <v-text-field
          :value="value.street"
          @input="emit('street', $event)"
          label="Calle"
          outlined dense
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        :value="value.number"
        @input="emit('number', $event)"
        label="Número"
        outlined dense
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="3">
      <v-text-field
        :value="value.suite"
        @input="emit('suite', $event)"
        label="Referencia"
        outlined dense
        placeholder="Piso, Depto"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AddressFormInline',
  props: {
    value: {
      type: Object,
      default: () => ({ region: '', city: '', comune: '', street: '', number: '', suite: '' })
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emit(field, val) {
      this.$emit('input', { ...this.value, [field]: val })
    }
  }
}
</script>
